import { useQuery } from 'react-query'
import request from '../../request'
import { useDealership } from '../../../store/zustand/dealershipStore'

export const useGetDisplayCampaignById = ({ campaign_id }: { campaign_id?: string }) => {
  const dealership = useDealership()
  return useQuery<any, Error>(
    ['campaigns', 'display', campaign_id],
    () =>
      request({
        url: `/agencies/${dealership?.organization_id}/dealership/${dealership?.id}/campaigns/display/${campaign_id}`,
        method: 'GET',
      }).then((res: any) => res.data),
    {
      enabled: !!campaign_id,
    },
  )
}
